"use client";

import type { SupportChatMessage } from "@/lib/support-chat/api";

export function MessageBubble({ message }: { message: SupportChatMessage }) {
  const isStaff = message.isStaff;
  const time = new Date(message.createdAt).toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className={`flex ${isStaff ? "justify-start" : "justify-end"}`}>
      <div
        className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm leading-relaxed whitespace-pre-wrap break-words ${
          isStaff
            ? "bg-neutral-100 text-neutral-900 dark:bg-neutral-800 dark:text-neutral-100 rounded-bl-sm"
            : "bg-red-500 text-white rounded-br-sm"
        }`}
      >
        {isStaff && message.staffName ? (
          <div className="text-[10px] font-medium uppercase tracking-wide opacity-70 mb-0.5">
            {message.staffName}
          </div>
        ) : null}
        <div>{message.body}</div>
        <div
          className={`text-[10px] mt-1 ${
            isStaff ? "text-neutral-500 dark:text-neutral-400" : "text-red-100"
          }`}
        >
          {time}
        </div>
      </div>
    </div>
  );
}
